import axios from 'axios';
import { API_CONFIG } from './config';

export const baseClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'ngrok-skip-browser-warning': API_CONFIG.SKIP_BROWSER_WARNING,
  },
});

baseClient.interceptors.request.use(async (config) => {
  const initData = window.Telegram?.WebApp?.initData || '';

  if (initData) {
    config.headers['X-Init-Data'] = initData;
  }
  return config;
});
